import * as React from 'react';
import { memo } from 'react';

const SvgShareLinkOutlined = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("circle", { cx: 23.65, cy: 6.65, r: 2.65, stroke: "currentColor", strokeWidth: 2 }),
    React.createElement("path", { d: "m21 8-11 6.5m0 3L21 24", stroke: "currentColor", strokeWidth: 1.8 }),
    React.createElement("circle", { cx: 7.65, cy: 16.05, r: 2.65, stroke: "currentColor", strokeWidth: 2 }),
    React.createElement("circle", { cx: 23.65, cy: 25.35, r: 2.65, stroke: "currentColor", strokeWidth: 2 })));
const Memo = memo(SvgShareLinkOutlined);

export { Memo as default };
